module.exports = __webpack_public_path__ + "static/img/logo.768f1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/logo.png
// module id = L4Nt
// module chunks = 1